import React, { useState } from 'react';
import './AboutPage.css';

const Accordion = ({ title, children, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="accordion">
      <div
        className={`accordion-header ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <h3>{title}</h3>
        <span className="accordion-icon">{isOpen ? '−' : '+'}</span>
      </div>
      {isOpen && (
        <div className="accordion-content">
          {children}
        </div>
      )}
    </div>
  );
};

const AboutPage = () => {
  return (
    <div className="about-page">
      <h1>КРАТКАЯ СУТЬ.</h1>
      <div>
        <p>Это приложение - надстройка над TELEGRAM, расширяющая его функции. Главные фичи:</p>
        <ul>
          <li>Два вида интерактивных графиков взаимосвязи всей группы пользователей. Один красивый , другой информативный. </li>
          <li>Возможность поиска по тегам среди пользователей. Какие теги укажете - по таким вас найдут. В том числе по тегу города.</li>
          <li>Доска объявлений, сообщения. Все дублируется в бот. Сообщения нужны чтобы сконнектиться, и перейти в TELEGRAM. </li>
          <li>В группе только друзья друзей, благодаря системе инвайтов. И все люди с которыми вы коннектитесь в этой среде - с понятной историей, благодаря информации о происхождении инвайта. </li>
        </ul>

        {/*
        // ============================================================================ //
        // === НАЧАЛО БОЛЬШОГО ЗАКОММЕНТИРОВАННОГО БЛОКА СОДЕРЖИМОГО СТРАНИЦЫ "О НАС" === //
        // ============================================================================ //
        // Чтобы раскомментировать, удалите эту строку и строку с "КОНЕЦ..." ниже,    //
        // а также символы комментария в начале этой строки ( {* ) и в конце ( *} )      //
        // ============================================================================ //

        <h2>ПОЧЕМУ VINCLE РАБОТАЕТ ИНАЧЕ?</h2>
        <p>При создании VINCLE я опирался на исследования того, как устроены наши социальные связи. Стэнли Милгрэм показал, как мы все связаны через цепочки знакомств («шесть рукопожатий»). Робин Данбар доказал, что по-настоящему глубокие, стабильные отношения возможны лишь в ограниченном круге. VINCLE использует эти принципы для создания уникальной среды:</p>

        <Accordion title="ПРИНЦИПЫ РАБОТЫ VINCLE">
          <div className="principle">
            <h3>1. ВАШ ЛИЧНЫЙ ФИЛЬТР: ПРИГЛАШАЙТЕ ОСОЗНАННО.</h3>
            <ul>
              <li>Вход в VINCLE – <strong>только по личному приглашению</strong>. Это не ограничение, а <strong>фундамент доверия</strong>. Вы сами решаете, кого добавить в свой круг.</li>
              <li><strong>Ключевой принцип:</strong> Формируйте свой круг, Приглашайте тех, кого вы действительно знаете и цените, создавая пространство для доверительного и содержательного общения. Тех, кого вы без колебаний назвали бы "своим человеком" для общения и обмена идеями.</li>
              <li><strong>Результат:</strong> Постепенно формируется <strong>ваш личный кластер</strong> интересных, адекватных людей, которым вы доверяете. Каждый участник, передавая инвайт, выступает фильтром, естественным образом отсеивая случайные контакты.</li>
            </ul>
          </div>

          <div className="principle">
            <h3>2. НАХОДИТЕ ПО СУТИ, А НЕ ПО ОБЛОЖКЕ.</h3>
            <ul>
              <li>Забудьте о лайках. В VINCLE <strong>сердце взаимодействия – это ваш профиль</strong> и слова, которыми вы себя описываете.</li>
              <li><strong>Как работает поиск:</strong> Он ищет совпадения по <strong>всем словам</strong> в полях вашего профиля (кроме имени): интересы, компетенции, цели, принципы, ресурсы.</li>
              <li><strong>Ваша Видимость Пропорциональна Наполненности:</strong> Чем детальнее вы опишете себя, тем легче релевантным людям вас найти по общим интересам. <strong>Хотите максимальной приватности?</strong> Просто не заполняйте детально поля. VINCLE уважает ваш выбор уровня открытости.</li>
              <li><strong>Активности:</strong> Еще один способ найти единомышленников для конкретных задач или идей, независимо от деталей профиля.</li>
            </ul>
          </div>

          <div className="principle">
            <h3>3. ПРОЗРАЧНОСТЬ СВЯЗЕЙ: "ТЕОРИЯ РУКОПОЖАТИЙ" В ДЕЙСТВИИ.</h3>
            <ul>
              <li>Никаких анонимных "друзей друзей". С VINCLE вы <strong>всегда понимаете, через кого вы связаны</strong> с другим человеком.</li>
              <li><strong>Функция "Путь приглашений"</strong> (доступна в профиле пользователя и при клике на аватар в сообщениях) наглядно <strong>показывает всю цепочку знакомств</strong>, соединяющую вас с любым участником сети.</li>
              <li><strong>Ценность:</strong> Это мгновенно создает контекст и повышает уровень доверия при первом контакте. Вы видите "историю рукопожатий".</li>
            </ul>
          </div>
        </Accordion>

        <Accordion title="КАК ЭФФЕКТИВНО ИСПОЛЬЗОВАТЬ VINCLE?">
          <ul>
            <li><strong>Решите, насколько вы хотите быть видимы:</strong> Заполните профиль детально для максимального нетворкинга или оставьте минимум для приватности.</li>
            <li><strong>Используйте поиск и активности:</strong> Ищите людей по ключевым словам, создавайте свои запросы.</li>
            <li><strong>Сообщения – для первого шага:</strong> Встроенные сообщения <strong>не шифруются</strong>. Используйте их <strong>только для установления контакта</strong> и обмена ссылками на основной Telegram-аккаунт. Не ведите здесь конфиденциальные переписки.</li>
            <li><strong>Приглашайте с умом:</strong> Помните об ограниченном количестве инвайтов. Делитесь ими с теми, кого вы действительно цените и хотите видеть в своем качественном круге.</li>
          </ul>
        </Accordion>

        {/* Заголовок "Почему Стоит Инвестировать Время в VINCLE?" удален *}
        <p>VINCLE – это не очередная соцсеть для прокрастинации. Это <strong>инструмент для осознанного нетворкинга и построения сообщества</strong>, основанного на доверии и общих интересах. Здесь вы:</p>
        <ul>
          <li><strong>Экономите время:</strong> Находите нужных людей быстрее благодаря поиску по сути.</li>
          <li><strong>Красивая структура:</strong> Уникальный интерактивный граф наглядно покажет, как устроена ваша сеть качественных связей.</li>
          <li><strong>Снижаете стресс:</strong> Взаимодействуете в предсказуемой и приятной среде без спама.</li>
          <li><strong>Строите ценные связи:</strong> Обнаруживаете людей, с которыми у вас действительно есть точки соприкосновения, благодаря прозрачности связей.</li>
          <li><strong>Контролируете свою сеть:</strong> Сами формируете свой круг общения и уровень своей видимости в нем.</li>
        </ul>

  // ========================================================================== //
        // === КОНЕЦ БОЛЬШОГО ЗАКОММЕНТИРОВАННОГО БЛОКА СОДЕРЖИМОГО СТРАНИЦЫ "О НАС" === //
        // ========================================================================== //
        */}
        <h1>ПРИМЕРЫ ИСПОЛЬЗОВАНИЯ:</h1>
      
      
        <ul>
          <li>Вам захотелось найти людей с понятной историей вашем городе, чтобы сходить завтра ночью погулять в лес. </li>
          <li>Хотите предложить что-то, но не хотели бы случайным людям это предлагать. </li>
          <li>Вам захотелось поиграть в бадминтон в парке ночью, но стремно идти неизвестно с кем. </li>
          <li>Хотите получить эстетическое удовольствие от просмотра графиков и диаграмм социальных зависимостей. </li>
          <li>Найти знакомства через друзей в другом городе, для какого то дела. </li>
          <li>Найти людей с общими интересами в рамках группы друзей друзей. </li>
        </ul>



        <h2>ПРИЛОЖЕНИЕ РАЗВИВАЕТСЯ!</h2>
        <p>Для связи с автором: </p>

        <a
          href="https://t.me/jatatreya"
          target="_blank"
          rel="noopener noreferrer"
          className="button button-primary contact-button"
          style={{ marginTop: '20px', display: 'inline-block' }}
        >
          Связаться с автором
        </a>

    
      </div>
    </div>
  );
};

export default AboutPage;